import {Logger} from '../utils/Logger';
import {isNullOrUndefined} from 'util';
import {Injectable, Type} from '@angular/core';
import {LoanApplicationFlowSteps} from './steps/loan-application-flow.steps';
import {AbstractApplicationFlowComponent} from './abstract-application-flow.component';
import {LoanApplicationComponentStepMapper} from './loan-application-component-step.mapper';
import {ActivatedRouteSnapshot, CanActivateChild, Router, RouterStateSnapshot} from '@angular/router';

@Injectable()
export class LoanApplicationFlowGuard implements CanActivateChild {
    private readonly router: Router;
    private readonly stepMapper: LoanApplicationComponentStepMapper;
    private readonly applicationFlowSteps: LoanApplicationFlowSteps;

    constructor(stepMapper: LoanApplicationComponentStepMapper, applicationFlowSteps: LoanApplicationFlowSteps, router: Router) {
        this.stepMapper = stepMapper;
        this.applicationFlowSteps = applicationFlowSteps;
        this.router = router;
    }

    async canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        const step = this.stepMapper.mapComponent(childRoute.component as Type<AbstractApplicationFlowComponent>);
        const incompleteStep = await this.applicationFlowSteps.findIncompleteStepPreviousTo(step);
        if (!isNullOrUndefined(incompleteStep)) {
            const urlToNavigateTo = incompleteStep.url();
            Logger.log(`Found [${incompleteStep.constructor.name}] to be incomplete. Navigating to the [${urlToNavigateTo}].`);
            this.router.navigate([urlToNavigateTo]);
            return false;
        } else {
            return true;
        }
    }
}